import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
          withCredentials: true,
        });
        localStorage.setItem("lme_token", data.token);
        setUser(data.user);
        // clear hash
        window.history.replaceState(null, "", "/feed");
        navigate("/feed", { replace: true });
        toast.success(`Welcome, ${data.user.name}`);
      } catch (err) {
        toast.error("Google sign-in failed");
        navigate("/auth", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={44} className="animate-spin text-rose-400 mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
